module.exports = __webpack_public_path__ + "static/img/1-1.1574d2f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/12/eng/1-1.png
// module id = +5rm
// module chunks = 0